import { render, staticRenderFns } from "./ContestCriteriaSectionComponent.vue?vue&type=template&id=9088bbea"
import script from "./ContestCriteriaSectionComponent.vue?vue&type=script&lang=js"
export * from "./ContestCriteriaSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestCriteriaSectionComponent.vue?vue&type=style&index=0&id=9088bbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports